import { Pagination } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import searchIcon from "assets/img/search.svg";

export const StyledPagination = styled(Pagination)`
  & input {
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    width: 32px;
    height: 32px;
    // border: 1px solid ${theme.palette.primary.light} !important;
    text-align: center !important;
    cursor: pointer;
    font-family: IRANSans;
}

& input::placeholder {
    padding-left: 20;
    background: url(${searchIcon}) no-repeat center center;
    background-size: 14px;
}

& textarea:focus,
input:focus {
    outline: none;
    border-bottom: 1px solid ${theme.palette.primary.light} !important;
}
`;
